<template>
  <div style="min-height: 100vh;background: #F9F9FF;overflow-x: hidden;width: 100%">
    <CommonHeader/>
    <div class="head-bg">
      <img style="margin: 0 auto" src="../../img/bg2.png">
      <div>
        <template v-if="kbsjList && kbsjList.length>0" v-for="kbsj in kbsjList">
               <span v-if="kbsj.code === 200">
                   {{kbsjList.length>1?kbsj.pack:''}} 距离开标还有
                    <span class="number">{{ kbsj.day }}</span>
                    天
                     <span class="number">{{ kbsj.hour }}</span>
                    小时
                </span>
          <span v-else-if="kbsj.code === 100">{{kbsjList.length>1?kbsj.pack:''}}{{ kbsj.msg }}</span></br>
        </template>

      </div>
    </div>
    <div class="container" style="margin-top: -43px;min-height: calc(100vh - 56px - 193px + 32px - 77px);">
      <a-tabs v-model="activeKey" class="t1" type="card" @change='tabChange'>
        <a-tab-pane key="1" tab="项目信息">
          <a-card>
            <a-row>
              <a-col :span="24">
                <h1 class="text-center"> {{ project.projectName }}</h1>
                <div class="d-flex justify-content-center border-bottom pb-5 mb-5">
                  <div class="pl-5 pr-5 border-right">
                    <span>项目编号：</span>
                    <span class="color-black bold">  {{ project.projectCode }}</span>
                  </div>
                  <div class="pl-5 pr-5">
                    <span>采购方式：</span>
                    <span class="color-black bold">
                                             {{ project.methodName }}
                                        </span>
                  </div>
                </div>
                <table class="fx-form-view">
                  <tr>
                    <th>报名期限</th>
                    <td>
                      {{ formatDate(project.signEnd) }}
                    </td>
                    <th>开标时间</th>
                    <td>
                      {{ formatDate(project.openTime) }}
                    </td>
                  </tr>
                  <tr>
                    <th>采购文件</th>
                    <td colspan="3">
                      <upload-selector :referId='project.id' readonly="readonly" configKey='purchase_doc'/>
                      <div v-for="it in announceList">
                        <upload-selector :referId='it.announceId' readonly="readonly" configKey='tender_file'/>
                      </div>
                      <upload-selector :referId='project.id' readonly="readonly" configKey='LEGAL_BID_ANNEX'/>
                    </td>
                  </tr>
                </table>
                <a-col :span="24">
                  <div class="d-division mt-5 mb-5"></div>
                  <a-col :span="24">
                    <a-divider class="color-orange mt-6" size="small" orientation="left">联系方式
                    </a-divider>
                  </a-col>
                  <div class="contact">
                    <div class="col">
                      <div class="title">招标代理机构</div>
                      <div class="info">
                        <table class="table-a">
                          <tr>
                            <th>代理机构名称：</th>
                            <td class="color-black">{{ project.tenderOrg }}</td>
                          </tr>
                          <tr>
                            <th>地址：</th>
                            <td class="color-black">{{ project.tenderAddress }}</td>
                          </tr>
                          <tr>
                            <th>经办人：</th>
                            <td class="color-black">{{ project.tenderOperator }}</td>
                          </tr>
                          <tr>
                            <th>联系电话：</th>
                            <td class="color-black">{{ project.tenderTel }}</td>
                          </tr>
                          <!--                                                    <tr>-->
                          <!--                                                        <th>电子邮件：</th>-->
                          <!--                                                        <td class="color-black">{{project.tenderEmail}}</td>-->
                          <!--                                                    </tr>-->
                        </table>
                      </div>
                    </div>
                    <div class="col">
                      <div class="title" style="background: #D8E5F3">采购人</div>
                      <div class="info">
                        <table class="table-a">
                          <tr>
                            <th>采购人名称：</th>
                            <td class="color-black">{{ project.purchaserUnit }}</td>
                          </tr>
                          <tr>
                            <th>地址：</th>
                            <td class="color-black">{{ project.purchaserAddress }}</td>
                          </tr>
                          <tr>
                            <th>经办人：</th>
                            <td class="color-black">{{ project.purchaserContacts }}</td>
                          </tr>
                          <tr>
                            <th>联系电话：</th>
                            <td class="color-black">{{ project.purchaserTel }}</td>
                          </tr>
                          <!--                                                    <tr>-->
                          <!--                                                        <th>电子邮件：</th>-->
                          <!--                                                        <td class="color-black">{{project.purchaserEmail}}</td>-->
                          <!--                                                    </tr>-->
                        </table>
                      </div>
                    </div>
                  </div>
                </a-col>
              </a-col>
            </a-row>
          </a-card>
          <div class="notice">
            <a-col :span="24">
              <a-divider class="color-orange mt-6" size="small" orientation="left">相关项目公告
              </a-divider>
            </a-col>
            <a-table :pagination="false" ref="table" :columns="columns2"
                     :rowKey="record => record.announceId"
                     :data-source="announceList">
              <template slot="name" slot-scope="text">
                <a>{{ text }}</a>
              </template>
              <template slot="announceName" slot-scope="record">
                <a href="javascript:;"
                   @click="skipAnnounce(record.announceId)">{{ record.announceName }}</a>
              </template>
              <template slot="openTime" slot-scope="record">
                {{ formatDate(record.publishTime) }}
              </template>
            </a-table>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="包组信息">
          <PacksInfo :projectId="id" :random="packRandom" :tenderType="project.tenderType"></PacksInfo>
        </a-tab-pane>
        <a-tab-pane key="3" tab="投标保证金">
          <BondInfo :projectId="id" :random="bondRandom" ref="bif"></BondInfo>
        </a-tab-pane>
        <!--                <a-tab-pane key="4" tab="项目答疑">-->
        <!--                    <AnswerInfo :projectId="id" :random="replyRandom" ref="ai"></AnswerInfo>-->
        <!--                </a-tab-pane>-->
        <a-tab-pane key="8" tab="采购结果">
          <CompeteResult :projectId="id" :currentSupplierId="currentSupplierId" :random="resultRandom"></CompeteResult>
        </a-tab-pane>
        <a-tab-pane key="6" tab="服务费和通知书">
          <DealServiceInfo :projectId="id" :random="serviceRandom"></DealServiceInfo>
        </a-tab-pane>
        <a-tab-pane key="7" tab="合同备案">
          <PreCase :projectId="id" :random="contractRandom"></PreCase>
        </a-tab-pane>
        <a-tab-pane key="9" tab="项目异议" v-if="false">
          <a-card>
            <a-empty style="margin: 200px 0">
              <DissentInfo :projectId="id" :random="dissentRandom"></DissentInfo>
            </a-empty>
          </a-card>
        </a-tab-pane>
      </a-tabs>
    </div>
    <CommonFooter/>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import qs from 'qs'
import CommonHeader from '../common/CommonHeader'
import CommonFooter from '../common/CommonFooter'
import UploadSelector from '@/components/selector/UploadSelector'
import CountDown from '@/components/CountDown/CountDown'
import PacksInfo from './PacksInfo'
import AnswerInfo from './AnswerInfo'
import DealServiceInfo from './DealServiceInfo'
import BondInfo from './BondInfo'
import moment from "moment";
import PreCase from './PreCase'
import DissentInfo from './DissentInfo'
import CompeteResult from './LegalResult'

const columns2 = [
  {
    title: '项目公告',
    // dataIndex: 'announceName',
    scopedSlots: {customRender: 'announceName'},
    align: 'left'
  },
  {
    title: '发布时间',
    // dataIndex: 'extras.openTime',
    scopedSlots: {customRender: 'openTime'},
    align: 'right',
  },
];
export default {
  name: 'LegalPacksList',
  components: {
    CommonHeader,
    CommonFooter,
    UploadSelector,
    CountDown,
    PacksInfo,
    AnswerInfo,
    DealServiceInfo,
    BondInfo,
    DissentInfo,
    PreCase,
    CompeteResult,
    moment
  },
  watch: {
    projectRandom: {
      immediate: false,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.initProjectInfo()
          this.initAnnounceList()
          this.countDown()
        }
      }
    },
    $route: {
      handler(newValue, oldValue) {
        console.log(newValue + " " + oldValue)
        alert(newValue + "  " + oldValue)
      },
      // 深度观察监听
      deep: true
    }
  },
  created() {
    this.initRandom()
  },
  destroyed() {
  },
  data() {
    return {
      columns2: columns2,
      form: this.$form.createForm(this),
      id: this.$route.query.id,
      currentSupplierId: '',
      project: '',
      announceList: [],
      kbsjList: [],
      projectRandom: '',
      packRandom: '',
      bondRandom: '',
      replyRandom: '',
      serviceRandom: '',
      resultRandom: '',
      contractRandom: '',
      dissentRandom: '',
      activeKey: "1"
    }
  },
  methods: {
    initRandom() {
      this.projectRandom = Math.random() + ""
      this.packRandom = Math.random() + ""
      this.bondRandom = Math.random() + ""
      this.replyRandom = Math.random() + ""
      this.serviceRandom = Math.random() + ""
      this.contractRandom = Math.random() + ""
      this.dissentRandom = Math.random() + ""
      this.resultRandom = Math.random()
      if (!sessionStorage.hasOwnProperty(this.id)) {
        sessionStorage[this.id] = 1
      }
      this.activeKey = sessionStorage[this.id]
    },
    formatDate(value) {
      if (!value) {
        return "未设置时间"
      }
      value = value.replace(new RegExp(/-/gm), "/")
      value = moment(new Date(value)).format("YYYY/MM/DD HH:mm")
      return value
    },
    initProjectInfo() {
      let that = this
      this.$http.get("/api/v1/supplier/legalBid/getPro/" + this.id).then(function (res) {
        if (res.code === 200) {
          that.project = res.result
          that.currentSupplierId = res.result.supplierId
        } else {
          that.$message.error('数据加载出错')
        }
      });
    },
    countDown() {
      let that = this
      this.$http.get('/api/v1/supplier/legalBid/getCountDownDate.json?projectId=' + this.id).then(function (res) {
        that.kbsjList = res
      })
    },
    initAnnounceList() {
      let that = this
      this.$http.get('/api/v1/supplier/notice/getAnnounce/' + this.id).then(function (res) {
        if (res.code === 200) {
          that.announceList = res.result
        }
      })
    },
    onEnd() {
      this.deadline = "已结束";
      this.title = ''
    },
    skipAnnounce(announceId) {
      let routeIndex = this.$router.resolve({
        path: '/project/LegalAnnounce?id=' + announceId
      })
      window.open(routeIndex.href, '_blank')
    },
    tabChange(activeKey) {
      switch (activeKey) {
        case '1':
          this.projectRandom = Math.random() + ""
          sessionStorage[this.id] = 1
          break;
        case '2':
          this.packRandom = Math.random() + ""
          sessionStorage[this.id] = 2
          break;
        case '3':
          this.bondRandom = Math.random() + ""
          sessionStorage[this.id] = 3
          break;
        case '4':
          this.replyRandom = Math.random() + ""
          sessionStorage[this.id] = 4
          break;
        case '5':
          sessionStorage[this.id] = 5
          break;
        case '6':
          this.serviceRandom = Math.random() + ""
          sessionStorage[this.id] = 6
          break;
        case '7':
          this.contractRandom = Math.random() + ""
          sessionStorage[this.id] = 7
          break;
        case '8':
          this.resultRandom = Math.random() + ""
          sessionStorage[this.id] = 8
          break;
      }
    },
  }
};
</script>
<style lang="less" scoped>

.head-bg {
  position: relative;
}

.head-bg div {
  position: absolute;
  top: 0;
  color: #fff;
  font-size: 36px;
  width: 100%;
  text-align: center;
  line-height: 60px;
  height: 60px;
  margin-top: 42px;
}

.head-bg div span {
  margin: 0 2px;
  display: inline-block;
  vertical-align: top;
}

.number {
  background: rgba(255, 22, 0, 0.35);
  font-size: 45px;
  padding: 0 12px;
}

.card-container /deep/ .ant-tabs-bar {
  margin: 0;
  border: none;
}

/deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar .ant-tabs-tab {
  border: none;
  padding-bottom: 0;
  line-height: 44px;
  border-radius: 0;
  color: #fff;
  background: rgba(255, 255, 255, 0.4);
  font-size: 16px;
  flex: 1;
  text-align: center;
  height: 44px;
}

/deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar .ant-tabs-tab:nth-last-child(1) {
  margin-right: 0;
}

/deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar .ant-tabs-tab-active {
  color: #1890ff;
  background: #fff;
}

/deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar .ant-tabs-nav-container {
  height: 44px;
}

/deep/ .t1.ant-tabs.ant-tabs-card .ant-card-bordered {
  border: none;
}

/deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar .ant-tabs-nav {
  display: block;
}

/deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar .ant-tabs-nav > div {
  display: flex;
}

/deep/ .t1.ant-tabs.ant-tabs-card > .ant-tabs-card-bar {
  margin-bottom: 0;
  border-bottom: none;
}

.table-a {
  table-layout: fixed;
}

.table-a td {
  vertical-align: top;
  padding: 8px 0;
  font-size: 14px;
  font-weight: bold;
}

.table-a th {
  text-align: justify;
  text-align-last: justify;
  color: #8c8c8c;
  font-weight: 500;
  padding: 8px 0;
}

.contact {
  font-size: 0;
  margin: 0 -12px;
}

.contact .col {
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  font-size: 14px;
  display: inline-block;
}

.contact .col .title {
  background: #F3E4D8;
  padding: 12px;
}

.contact .col .info {
  border: 1px solid #e6e6e6;
  padding: 12px;
}

/deep/ .notice .p-0 .ant-card-body {
  padding: 0;
}

/deep/ .notice .ant-tabs-nav .ant-tabs-tab {
  font-size: 20px;
  font-weight: bold;
}

/deep/ .notice .ant-tabs-bar {
  margin-bottom: 0;
  border-bottom: 3px solid #e6e6e6;
}

/deep/ .ant-table-thead > tr > th, /deep/ .ant-table-tbody > tr > td {
  background: #fff;
}

.fx-form-view th {
  border: 1px solid #e6e6e6;
  background-color: #f7f7f7;
}

.fx-form-view td {
  border: 1px solid #e6e6e6;
  width: 400px;
}

.fx-form-view {
  table-layout: auto;
}
</style>
